import React, {useEffect, useState} from 'react';
import './App.scss';
import PlaceResult = google.maps.places.PlaceResult;
import SelectLocationStep from "./FormSteps/SelectLocationStep";
import DataFormStep from "./FormSteps/DataFormStep";
import SummaryStep from "./FormSteps/SummaryStep";
import {DataFormValues} from "./DataForm";
import {getShareReportHash} from "./helpers";
import Introduce from "./Introduce";

export type Marker = {
    latLng: google.maps.LatLngLiteral,
    name: string | null,
    rainWater: number | null | undefined,
    rainWaterDescription: string | null | undefined,
}

export type CalculatedRainWater = {
    expectedRainWater: number,
    requiredRainWater: number,
    minSizeTank: number|null,
    recommendedSizeTank: number|null
}

export type Step = {
    index: number,
    name: string,
}

const steps: { [key: string]: Step }= {
    'selectLocation': {index: 1, name: 'Wybierz lokalizację'},
    'dataFrom': {index: 2, name: 'Uzupełnij dane'},
    'summary': {index: 3, name: 'Raport'},
    'loading': {index: 3, name: 'Raport'},
    'reportError': {index: 3, name: 'Raport'},
}

function App() {
    const [step, setStep] = useState<string>('selectLocation');
    const [showIntroduce, setShowIntroduce] = useState<boolean>(true);
    const [marker, setMarker] = useState<Marker|undefined>(undefined);
    const [calculatedRainWater, setCalculatedRainWater] = useState<CalculatedRainWater|null>(null);
    const [formValues, setFormValues] = useState<DataFormValues>({
        roofArea: undefined,
        roofMaterial: 0.9,
        gardenArea: undefined,
        numberPeople: undefined,
        waterUses: [],
        enableExtraFields: false
    });

    useEffect(() => {
      console.log('Update', marker, calculatedRainWater);
    })

    useEffect(() => {
        console.log('init');

        const reportHash = getShareReportHash();
        if (reportHash) {
            setStep('loading');
            getLinkData(reportHash);
        }
    }, [])

    const getLinkData = async (reportHash: string) => {
        setShowIntroduce(false);

        const reqHost = window.location.host == 'localhost:3000' ? 'http://localhost:8000/' : '/';
        const data = await fetch(
            reqHost + "wp-json/rainwatercalculator/report/link/" + reportHash
        ).then((response) => response.json());

        console.log(data);
        if (data.error || !data.params) {
            setStep('reportError')
            return;
        }

        const params = JSON.parse(data.params);
        console.log(params);
        setCalculatedRainWater(params.calculatedRainWater)
        setMarker(params.marker)
        setStep('summary');
    }

    const onPlaceSelected = (place: PlaceResult) => {
        if (!place.geometry) {
            return;
        }

        const newMarker = {
            latLng: { lat: place.geometry.location?.lat(), lng: place.geometry.location?.lng() },
            name: place.formatted_address ?? null,
            rainWater: undefined,
        };

        // @ts-ignore
        setMarker(newMarker);
        setCalculatedRainWater(null);
        console.log(newMarker);
    }

    const renderLoading = () => {
        return <div className='loadingContainer'>
            <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    }
    const renderStep = () => {
        switch (step) {
            case 'selectLocation':
                return <SelectLocationStep
                    marker={marker}
                    setMarker={setMarker}
                    onPlaceSelected={onPlaceSelected}
                    setStep={setStep}
                />;
            case 'dataFrom':
                return <DataFormStep
                    marker={marker}
                    setCalculatedRainWater={setCalculatedRainWater}
                    setStep={setStep}
                    formValues={formValues}
                    setFormValues={setFormValues}
                />;
            case 'summary':
                return <SummaryStep
                    calculatedRainWater={calculatedRainWater}
                    setStep={setStep}
                    marker={marker}
                />
            case 'loading':
                return renderLoading();
            case 'reportError':
                return <b>Nie znaleziono raportu</b>;
            default:
                return <div>Not Found</div>;
        }
    }

    return (
        <div className="App">
            {showIntroduce && <Introduce setShowIntroduce={setShowIntroduce}/>}
            {!showIntroduce && <div>
                <div className={'step'}>
                    {/*// @ts-ignore*/}
                    <b>{steps[step].index} z 3 {steps[step].name}</b>
                    <div className="progress">
                        <div className="progress-bar" role="progressbar" style={{width: '33%', backgroundColor: '#f4c900'}}></div>
                        {(step === 'dataFrom' || step === 'summary' || step === 'loading') && <div className="progress-bar" role="progressbar" style={{width: '33%', backgroundColor: '#78b324'}}></div>}
                        {(step === 'summary'|| step === 'loading') && <div className="progress-bar" role="progressbar" style={{width: '34%', backgroundColor: '#0092d7'}}></div>}
                    </div>
                </div>
                {renderStep()}
            </div>}
        </div>
    );
}

export default App;
